"use client";

import type { FC, Ref } from "react";
import { DataCard } from "@huub-web/ui";

import {
  ToggleInputTemplate,
  type ToggleInputTemplateProps,
} from "../ToggleInputTemplate";

export interface DataCardTemplateProps {
  /**
   * The title of the card
   */
  title: string;
  /**
   * Will render an avatar with initials if provided
   */
  name?: string;
  /**
   * Will render a toggle input for each item in the array
   */
  inputs?: ToggleInputTemplateProps[];
}

/**
 * A template for a data card.
 */
export const DataCardTemplate: FC<
  DataCardTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ title, inputs, ref }) => (
  <DataCard ref={ref} title={title}>
    {inputs?.map(({ ...props }, index) => (
      <ToggleInputTemplate key={index} {...props} />
    ))}
  </DataCard>
);
